// extracted by mini-css-extract-plugin
export default {"wrapper":"TutorWebinarMedia_wrapper__HNEFC","pinned":"TutorWebinarMedia_pinned__Wqt18","peers":"TutorWebinarMedia_peers__fa94P","list":"TutorWebinarMedia_list__Fqokj"};